import React, {FC, useCallback, useEffect} from "react";
import {TouristForm} from "@src/pages/Tours/TourFormalization/components/steps/Step2/TouristForm";
import style from '@src/pages/Tours/TourFormalization/components/steps/Step2/Step2.module.scss'
import {useFormikContext} from "formik";
import * as Yup from "yup";
import {validateForm} from "@src/messages/validateForm";
import {Button} from "@src/components/Button/Button";
import {Success} from "@src/components/AllSvg/Success";
import {useDispatch, useSelector} from "react-redux";
import {selectUserInfo} from "@src/store/ducks/user/selectors";
import {getHistoryNewArrCityAsync} from "@src/store/ducks/orders/thunks";

type Step2Props = {
    vehicleType: string;
    quantity: number;
    registerValidator: (fn: () => Promise<boolean>) => void;
    data:any
};


const validationSchema1 = Yup.object().shape({
    data: Yup.object().shape({
        tourists: Yup.array().of(
            Yup.object().shape({
                fio: Yup.string().required(validateForm.required),
                birthDate: Yup.string().required(validateForm.required),
                passportIssueDate: Yup.string().required(validateForm.required),
                passportExpiryDate: Yup.string().required(validateForm.required),
                passportSeriesAndNumber: Yup.string().required(validateForm.required),
                phoneNumber: Yup.string().required(validateForm.required),
            })
        ),
    }),
    selectsArr: Yup.array().of(
        Yup.object().shape({
            fromCity: Yup.mixed().required(validateForm.required),
            roomType: Yup.mixed().required(validateForm.required),
            gender: Yup.mixed().required(validateForm.required),
            // citizenCategory: Yup.mixed().required(validateForm.required),
        })
    ),
});
const validationSchema2 = Yup.object().shape({
    data: Yup.object().shape({
        tourists: Yup.array().of(Yup.object().shape({
            fio: Yup.string().required(validateForm.required),
            birthDate: Yup.string().matches(/^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/, 'Неверный формат даты').required(validateForm.required),
        }))
    }),
})



export const HistoryPreOrderStep2: FC<Step2Props> = ({
                                                         vehicleType,
                                                         quantity,
                                                         registerValidator,
                                                         data
                                                     }) => {
    const { values, setFieldTouched, setFieldError } = useFormikContext<any>();
    const user = useSelector(selectUserInfo)

    const validateStep = useCallback(async () => {
        try {
            for (let i = 0; i < quantity; i++) {
                const t = `data.tourists[${i}]`;
                const s = `selectsArr[${i}]`;

                setFieldTouched(`${t}.fio`, true);
                setFieldTouched(`${t}.birthDate`, true);
                setFieldTouched(`${t}.passportIssueDate`, true);
                setFieldTouched(`${t}.passportExpiryDate`, true);
                setFieldTouched(`${t}.passportSeriesAndNumber`, true);
                setFieldTouched(`${t}.phoneNumber`, true);

                setFieldTouched(`${s}.fromCity`, true);
                setFieldTouched(`${s}.roomType`, true);
                setFieldTouched(`${s}.gender`, true);
                setFieldTouched(`${s}.citizenCategory`, true);
            }

            if (user.roleId === 2) {
                await validationSchema1.validate(values, {abortEarly: false})
            } else {
                await validationSchema2.validate(values, {abortEarly: false})
            }
            return true;
        } catch (err: any) {
            err.inner.forEach((e: any) =>
                setFieldError(e.path, e.errors[0])
            );
            return false;
        }
    }, [values, quantity]);

    useEffect(() => {
        registerValidator(validateStep);
    }, [validateStep]);

    return (
        <div className={style['step-2']}>
            {Array.from({ length: quantity }).map((_, index) => (
                <TouristForm
                    key={index}
                    namePart={`data.tourists[${index}]`}
                    nameSelectArr={`selectsArr[${index}]`}
                    num={index + 1}
                    cityArr = {data.citiesArrHistory}
                />
            ))}
        </div>
    );
};


